

























































import { Component, Vue, Mixins } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'
import RadioToggle from '@/components/common/atoms/RadioToggle.vue'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import SelectOptionsApis from '@/mixins/requests/admin/SelectOptionsApis.vue'
import HelpEditApis, { HelpEditItem, HelpValidationMessage } from '@/mixins/requests/admin/HelpEditApis.vue'
import { ApiResponse } from '@/plugins/http'

@Component({
  components: {
    ButtonBase,
    SelectBase,
    RadioToggle,
    InputSimple,
  },
})
export default class HelpEdit extends Mixins(HelpEditApis, SelectOptionsApis) {
  /** ロードが完了し編集可能状態か判定 */
  private isEditable = false
  /** バリデーション表示フラグ */
  private displayValidation = true

  /** ヘルプグループ一覧 */
  private helpGroupOptions: SelectOption[] = []
  /** ヘルプグループID */
  private helpGroupId: SelectOption['value'] = ''
  /** ヘルプ情報 */
  private helpEditItem: HelpEditItem = {
    helpGroupId: '',
    sortNum: 1,
    title: '',
    isVisible: true,
    message: '',
  }

  /**
   * Vue2Editorツールバーカスタム設定
   * + 標準ツールバー設定
   *   [{ header: [false, 1, 2, 3, 4, 5, 6] }],
   *   ['bold', 'italic', 'underline', 'strike'], // toggled buttons
   *   [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
   *   ['blockquote', 'code-block'],
   *   [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
   *   [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
   *   [{ color: [] }, { background: [] }], // dropdown with defaults from theme
   *   ['link', 'image', 'video'],
   *   ['clean'], // remove formatting button
   */
  private customToolbar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
  ]

  /**
   * ヘルプID（URLクエリパラメーター部分）
   */
  private get helpContentId(): number | null {
    const helpContentId = this.$route.query['helpContentId']
    return !helpContentId || helpContentId instanceof Array ? null : Number(helpContentId)
  }

  /**
   * バリデーションメッセージ反映
   */
  private get validationMessage(): HelpValidationMessage {
    const validation = {
      helpGroupId: '',
      sortNum: '',
      title: '',
      message: '',
    }

    // 「グループ」検証
    if (!this.helpEditItem.helpGroupId) {
      validation.helpGroupId = '*グループを選択してください'
    }
    // 「並び順」検証
    if (!this.helpEditItem.sortNum) {
      validation.sortNum = '*並び順を選択してください'
    } else {
      const sortNum = Number(this.helpEditItem.sortNum)
      if (!Number.isInteger(sortNum) || sortNum < 1 || sortNum > 9999) {
        validation.sortNum = '*正の整数（1〜9999）を入力してください'
      }
    }
    // 「件名」検証
    if (!this.helpEditItem.title) {
      validation.title = '*件名を入力してください'
    } else if (this.helpEditItem.title.length > 50) {
      validation.title = '*件名は50文字までです'
    }
    // 「内容」検証
    if (!this.helpEditItem.message) {
      validation.message = '*内容を入力してください'
    }

    return validation
  }

  /**
   * 「保存」が可能な状態であるか判定
   */
  private get isSaveAllowed(): boolean {
    return Object.values(this.validationMessage).every((str) => str === '')
  }

  /**
   * 「保存」ボタンのカラー（アクティブ）判定
   */
  private get colorTypeSaveButton(): string {
    return this.isSaveAllowed ? '' : 'pointer-events-none'
  }

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      await this.helpGroupSelectOptions()

      if (this.helpContentId) {
        const helpItem = await this.showHelpItemApi(this.helpContentId)
        if (helpItem) {
          this.helpEditItem = helpItem
          this.helpGroupId = this.helpEditItem.helpGroupId
        } else await this.$router.push({ name: 'AdminHelpEdit' })
      }
    } finally {
      this.isEditable = true
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * ヘルプグループ一覧取得
   */
  private async helpGroupSelectOptions(): Promise<void> {
    this.helpGroupOptions = await this.helpGroupSelectOptionsApi()
  }

  /**
   * ヘルプグループ変更
   */
  private onChangeHelpGroup(helpGroupId: SelectOption['value']): void {
    this.helpEditItem.helpGroupId = helpGroupId
  }

  /**
   * 表示有無切り替え
   */
  private async onClickIsVisibleToggle(isVisible: boolean): Promise<void> {
    this.helpEditItem.isVisible = isVisible
  }

  /**
   * 「保存」ボタンクリック処理
   */
  private async onClickSaveButton(helpContentId: number): Promise<void> {
    if (!this.isSaveAllowed) {
      this.displayValidation = true
    } else {
      this.displayValidation = false
      Vue.prototype.$loading.start()
      if (helpContentId === null) {
        // 新規作成
        await this.createHelpItemApi(
          this.helpEditItem,
          async () => {
            await this.$router.push({ name: 'AdminHelp' })
          },
          async (error: ApiResponse | null) => {
            if (error && error.status === 400) {
              Vue.prototype.$logger.log(error)
              alert(error.message)
            }
          }
        )
      } else {
        // 更新編集
        await this.updateHelpItemApi(
          helpContentId,
          this.helpEditItem,
          async () => {
            alert('保存しました')
            await this.$router.push({ name: 'AdminHelp' })
          },
          async (error: ApiResponse | null) => {
            if (error && error.status === 400) {
              Vue.prototype.$logger.log(error)
              alert(error.message)
            }
          }
        )
      }
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 「保存せずに戻る」ボタンクリック処理
   */
  private onClickBack(): void {
    this.$router.push({ name: 'AdminHelp' })
  }
}
